var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: false } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label: _vm.$t(
                            "apeironGwApp.actividadesRetribucion.campos.areaConocimiento"
                          ),
                          "label-for": "form-area-conocimiento",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.opcionesAreasConocimiento,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-area-conocimiento",
                                  },
                                  model: {
                                    value: _vm.vinculacionForm.areaConocimiento,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.vinculacionForm,
                                        "areaConocimiento",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "vinculacionForm.areaConocimiento",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label: _vm.$t(
                            "apeironGwApp.actividadesRetribucion.campos.temaPrioritario"
                          ),
                          "label-for": "form-tema-prioritario",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: _vm.opcionesPrioridades,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-tema-prioritario",
                                  },
                                  model: {
                                    value:
                                      _vm.vinculacionForm.temasPrioritarios,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.vinculacionForm,
                                        "temasPrioritarios",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "vinculacionForm.temasPrioritarios",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.otroTemaPrioritario"
                              ) + ":",
                            "label-for": "form-otro-tema",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "form-otro-tema" },
                            model: {
                              value: _vm.vinculacionForm.otroTemaPrioritario,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.vinculacionForm,
                                  "otroTemaPrioritario",
                                  $$v
                                )
                              },
                              expression: "vinculacionForm.otroTemaPrioritario",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.esReadOnly
                ? _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.esEscritura
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.desactivarBoton,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.guardarVinculacion()
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }